import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=321e6810&scoped=true&"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts&"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=321e6810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e6810",
  null
  
)

export default component.exports